import script from "./BaseDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./BaseDropdown.vue?vue&type=style&index=0&id=d73e9886&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d73e9886"]])

export default __exports__